import React from "react";
import { Route, Routes } from "react-router-dom";
import { IconClipboardList, IconHistory } from "@tabler/icons-react";
import { HasAction } from "components/Auth/HasAction";
import { useActions } from "context/ActionsContext";
import DashboardCards from "components/Dashboard/DashboardCard";
import DashboardHeader from "components/Dashboard/DashboardHeader";
import { TRANSACTION_MANAGER_HUB_ACTIONS } from "lib/hubAccess";
import PendingApprovals from "./PendingApprovals";
import TransactionDetail from "./TransactionDetail";
import TransactionHistory from "./TransactionHistory";

/**
 * TransactionManagerHub
 *
 * Hub for league staff to manage transaction approvals.
 * Provides access to pending transactions, approval workflow,
 * and transaction history.
 */
export default function TransactionManagerHub() {
  return (
    <HasAction action={[...TRANSACTION_MANAGER_HUB_ACTIONS]}>
      <Routes>
        <Route path="/" element={<TransactionManagerDashboard />} />
        <Route path="/pending" element={<PendingApprovals />} />
        <Route path="/history" element={<TransactionHistory />} />
        <Route path="/transactions/:transactionId" element={<TransactionDetail />} />
      </Routes>
    </HasAction>
  );
}

function TransactionManagerDashboard() {
  const { hasAnyAction } = useActions();

  const allElements = [
    {
      label: "Pending Approvals",
      description: "Review and approve pending transactions",
      icon: IconClipboardList,
      color: "orange",
      path: "pending",
      actions: ["transaction:approve", "transaction:list"],
    },
    {
      label: "Transaction History",
      description: "View completed transactions",
      icon: IconHistory,
      color: "blue",
      path: "history",
      actions: ["transaction:list", "transaction:view"],
    },
  ];

  const elements = allElements.filter((el) => hasAnyAction(el.actions));

  return (
    <div>
      <DashboardHeader
        title="Transaction Manager Hub"
        subtitle="Review, approve, and manage league transactions"
      />
      <DashboardCards elements={elements} />
    </div>
  );
}
